<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.users')"></general-top-bar> -->
    <!--End General Top Bar -->
    <template v-if="userRole != 'USER_CUSTOM'">
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="users-filters" style="display: flex; flex-wrap: wrap; gap: 8px; align-items: flex-end; justify-content: space-between; margin-bottom: 15px;">
            <div style="display: flex; flex-wrap: wrap; gap: 8px; align-items: flex-end; flex: 1 1 auto;">
              <div class="form-group" style="max-width: 150px; margin-bottom: 0;">
                <label>ID</label>
                <el-input
                  v-model="filters.id"
                  :placeholder="'ID'"
                  @keyup.enter.native="handleSearch"
                ></el-input>
              </div>
              <div class="form-group" style="max-width: 220px; margin-bottom: 0;">
                <label>{{ $t('settingUsers.fn') }} / {{ $t('settingUsers.ln') }}</label>
                <el-input
                  v-model="filters.name"
                  :placeholder="$t('settingUsers.fn') + ' / ' + $t('settingUsers.ln')"
                  @keyup.enter.native="handleSearch"
                ></el-input>
              </div>
              <div class="form-group" style="max-width: 220px; margin-bottom: 0;">
                <label>{{ $t('settingUsers.email') }}</label>
                <el-input
                  v-model="filters.email"
                  :placeholder="$t('settingUsers.email')"
                  @keyup.enter.native="handleSearch"
                ></el-input>
              </div>
              <div class="form-group" style="max-width: 220px; margin-bottom: 0;">
                <label>{{ $t('settingUsers.role') }}</label>
                <el-select
                  v-model="filters.role"
                  clearable
                  :placeholder="$t('settingUsers.role')"
                  class="filter-select"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="role in roleOptions"
                    :key="role"
                    :label="$t('settingUsers.' + role)"
                    :value="role">
                  </el-option>
                </el-select>
              </div>
              <div class="search-button-reports" style="margin-bottom: 0;">
                <button
                  :title="$t('general.search')"
                  class="btn add mar-rt-10"
                  @click.prevent="handleSearch"
                >
                  <i class="ti-search"></i>
                  <span>{{ $t('general.search') }}</span>
                </button>
              </div>
            </div>
            <p class="" style="margin-bottom: 0;">
              <button class="btn add mar-rt-10"  @click.prevent="goToAdd" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
                <img src="/static/img/icons/add.png">
                {{$t('general.add')}}
              </button>
            </p>
          </div>
          <data-tables
                v-loading="loading"
                :data="tableData"
                ref="userList"
                :search-def="{}"
                :pagination-def="{}"
                :table-props="{'border': false}"
                @row-click="goToRecord"
                style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                            :key="column.label"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            sortable>
            </el-table-column>
            <el-table-column :min-width="150" prop="role" :label="$t('settingUsers.role')" >
              <template slot-scope="props">
                {{$t('settingUsers.' + props.row.role)}}
              </template>
            </el-table-column>
            <el-table-column
                  :width="145">
              <template slot-scope="props">
                <div class="edit" @click="goToRecord(c,[],[], $event)">
                  <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </template>
    <template v-else>
      <h3>{{$t('general.noAccessUsers')}}</h3>
    </template>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Option, Pagination, Select} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  // import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(Select)
  Vue.use(DataTables)
  export default {
    components: {
      PPagination,
      // GeneralTopBar,
      [Input.name]: Input,
      [Select.name]: Select,
      [Option.name]: Option
    },
    props: {
      callback: {
        required: false
      },
      callbackAdd: {
        required: false
      },
      isUsers: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.userRole = this.$session.get('userDataRole')
      this.getData()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    data () {
      return {
        loading: true,
        userRole: null,
        filters: {
          id: '',
          name: '',
          email: '',
          role: ''
        },
        roleOptions: [
          'OWNER',
          'DRIVER',
          'USER',
          'LOCATION_ADMIN',
          'LOCATION_STORE_ADMIN',
          'MARKETER',
          'OPERATOR',
          'KDS_OPERATOR',
          'USER_CUSTOM',
          'DISPATCHER'
        ],
        tableColumns: [
          {
            prop: 'id',
            label: 'ID',
            minWidth: 100
          },
          {
            prop: 'firstname',
            label: this.$t('settingUsers.fn'),
            minWidth: 100
          },
          {
            prop: 'lastname',
            label: this.$t('settingUsers.ln'),
            minWidth: 100
          }
          // {
          //   prop: 'role',
          //   label: this.$t('settingUsers.role'),
          //   minWidth: 150
          // }
        ],
        tableData: []
      }
    },
    methods: {
      handleRefresh () {
        this.getData()
      },
      handleSearch () {
        this.getData()
      },
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/user/edit/')
        // if (typeof this.callback === 'function') {
        //   this.callback(row.id)
        //   console.log(row.id)
        // } else {
        //   this.globalGoToRecord(row, event, column, '/user/edit/')
        // }
      },
      getData () {
        var self = this
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        if (this.filters.id !== null && String(this.filters.id).trim() !== '') {
          data.id = String(this.filters.id).trim()
        }
        if (this.filters.name !== null && String(this.filters.name).trim() !== '') {
          data.name = String(this.filters.name).trim()
        }
        if (this.filters.email !== null && String(this.filters.email).trim() !== '') {
          data.email = String(this.filters.email).trim()
        }
        if (this.filters.role !== null && String(this.filters.role).trim() !== '') {
          data.role = String(this.filters.role).trim()
        }

        this.loading = true
        this.apiRequest('/profile', 'GET', data, function (response) {
          if (response.status === true) {
            self.tableData = response.data

            self.$nextTick(function () {
              self.loading = false
            })
          } else {
            self.loading = false
          }
        })
      },
      goToAdd () {
        if (typeof this.callback === 'function') {
          this.callback(null)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Users/Users.vue